export interface HrCalendar {
  calendarId?: number;
  owningCompanyId?: number;
  calendarCode?: string;
  calendarName?: string;
  weekendDays?: string;
  defaultCalendar?: boolean;
  active?: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrHoliday {
  holidayId?: number;
  owningCompanyId?: number;
  calendarId?: number;
  holidayDate?: string;
  holidayName?: string;
  paidHoliday?: boolean;
  active?: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrLeaveType {
  leaveTypeId?: number;
  owningCompanyId?: number;
  leaveCode?: string;
  leaveName?: string;
  paidLeave?: boolean;
  requiresBalance?: boolean;
  annualEntitlementDays?: number;
  allowNegativeBalance?: boolean;
  emergencyLeave?: boolean;
  colorCode?: string;
  active?: boolean;
  systemDefault?: boolean;
  description?: string;
}

export interface HrLeaveBalance {
  leaveBalanceId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  leaveTypeId?: number;
  leaveCode?: string;
  leaveName?: string;
  balancePeriodStart?: string;
  balancePeriodEnd?: string;
  entitledDays?: number;
  accruedDays?: number;
  usedDays?: number;
  pendingDays?: number;
  adjustmentDays?: number;
  availableDays?: number;
  payrollInputCode?: string;
  recalculatedAt?: string;
}

export interface HrLeaveRequestEvent {
  leaveRequestEventId?: number;
  leaveRequestId?: number;
  employeeId?: number;
  eventType?: string;
  oldStatus?: string;
  newStatus?: string;
  reason?: string;
  eventByCustomerId?: number;
  eventAt?: string;
}

export interface HrLeaveRequest {
  leaveRequestId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  leaveTypeId?: number;
  leaveCode?: string;
  leaveName?: string;
  requestStatus?: string;
  startDate?: string;
  endDate?: string;
  requestedDays?: number;
  paidDays?: number;
  unpaidDays?: number;
  reason?: string;
  emergencyLeave?: boolean;
  assignmentConflictWarning?: boolean;
  conflictSummary?: string;
  payrollInputJson?: string;
  submittedByCustomerId?: number;
  submittedAt?: string;
  approvedByCustomerId?: number;
  approvedAt?: string;
  rejectedByCustomerId?: number;
  rejectedAt?: string;
  decisionReason?: string;
  createdAt?: string;
  updatedAt?: string;
  events?: HrLeaveRequestEvent[];
}

export interface HrLeaveDashboard {
  owningCompanyId?: number;
  pendingRequests?: number;
  approvedThisMonth?: number;
  rejectedThisMonth?: number;
  employeesOnLeaveToday?: number;
  requestsWithConflicts?: number;
  activeLeaveTypes?: number;
  pendingApprovals?: HrLeaveRequest[];
  upcomingApprovedLeave?: HrLeaveRequest[];
  balances?: HrLeaveBalance[];
  leaveTypes?: HrLeaveType[];
}

export interface HrLeaveCalendarEntry {
  leaveRequestId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  leaveCode?: string;
  leaveName?: string;
  requestStatus?: string;
  startDate?: string;
  endDate?: string;
  requestedDays?: number;
  colorCode?: string;
}

export interface HrLeaveDecisionRequest {
  owningCompanyId?: number;
  decisionReason?: string;
}

export interface HrLeaveBalanceRecalculateRequest {
  owningCompanyId?: number;
  employeeId?: number;
  periodStart?: string;
  periodEnd?: string;
}

export const HR_LEAVE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'];

